import { EsriJSON } from 'ol/format'

const format = new EsriJSON()

export function createEsriLoader({
  serviceUrl,
  layer,
}) {
  return async function (extent, resolution, projection) {
    const url
      = `${serviceUrl}${layer}/query/?f=json`
        + '&returnGeometry=true'
        + '&spatialRel=esriSpatialRelIntersects'
        + '&geometry='
        + encodeURIComponent(JSON.stringify({
          xmin: extent[0],
          ymin: extent[1],
          xmax: extent[2],
          ymax: extent[3],
          spatialReference: { wkid: 102100 },
        }))
        + '&geometryType=esriGeometryEnvelope'
        + '&inSR=102100'
        + '&outFields=*'
        + '&outSR=102100'

    try {
      const response = await fetch(url)
      const json = await response.json()

      if (json.error) {
        console.error(json.error)
        return
      }

      const features = format.readFeatures(json, {
        featureProjection: projection,
      })

      this.addFeatures(features) // IMPORTANT: "this" = source
    }
    catch (err) {
      console.error('ESRI loader error:', err)
    }
  }
}
